var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGocrm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.63226 19.1805H11.4619V12.7852H6.63226V19.1805Z",
    fill: "#7E63D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66437 11.7081H11.4614V7.86523H5.66437V11.7081Z",
    fill: "#7E63D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5371 11.7081H18.3342V7.86523H12.5371V11.7081Z",
    fill: "#7E63D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5371 19.1805H17.3671V12.7852H12.5371V19.1805Z",
    fill: "#7E63D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4125 12.7853H18.4454V20.2578H5.55459V12.7853H4.58753V6.78847H7.39482C7.23529 6.49588 7.14423 6.16059 7.14423 5.80412C7.14423 4.66729 8.06929 3.74259 9.20576 3.74259C10.0465 3.74259 10.9066 4.17671 11.5662 4.93447C11.7296 5.12188 11.8751 5.32341 12 5.53306C12.1253 5.32306 12.2714 5.12188 12.4341 4.93447C13.0927 4.17706 13.9535 3.74259 14.7942 3.74259C15.9307 3.74259 16.8558 4.66729 16.8558 5.80412C16.8558 6.16059 16.7647 6.49588 16.6048 6.78847H19.4125V12.7853ZM12 0C5.37282 0 0 5.37282 0 12C0 18.6268 5.37282 24 12 24C18.6272 24 24 18.6268 24 12C24 5.37282 18.6275 0 12 0Z",
    fill: "#7E63D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20515 6.78707C8.66232 6.78707 8.22079 6.34554 8.22079 5.80271C8.22079 5.25989 8.66232 4.81836 9.20515 4.81836C10.1831 4.81836 11.1114 5.81789 11.3824 6.78707H9.20515Z",
    fill: "#7E63D4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.778 5.80271C15.778 5.25989 15.3365 4.81836 14.7936 4.81836C13.816 4.81836 12.887 5.81789 12.6163 6.78707H14.7936C15.3365 6.78707 15.778 6.34554 15.778 5.80271Z",
    fill: "#7E63D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGocrm);
export default __webpack_public_path__ + "static/media/gocrm.01200777.svg";
export { ForwardRef as ReactComponent };